import { render } from "./AbChips.vue?vue&type=template&id=91e3222e"
import script from "./AbChips.vue?vue&type=script&lang=js"
export * from "./AbChips.vue?vue&type=script&lang=js"

import "./AbChips.vue?vue&type=style&index=0&id=91e3222e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__